import { render, staticRenderFns } from "./BiddingHistory.vue?vue&type=template&id=614e4eb1&"
import script from "./BiddingHistory.vue?vue&type=script&lang=js&"
export * from "./BiddingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports